// Check if platform is Mac or iPad
export default function isMacLike () {
  return typeof navigator !== 'undefined' && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
}
